(function (Drupal, $, settings) {

  Drupal.behaviors.onetrustFooter = {
    attach: function attach(context) {
      $('a.onetrust-manual-modal').each(function(){
        $(this).on('click', function(){
          if ( OneTrust !== undefined ) {
            OneTrust.ToggleInfoDisplay();
          }
          return false;
        });
      });
    }
  };
})(Drupal, jQuery, drupalSettings);
